import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { ObjekteServiceModule } from '..';
import { ObjekteListComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    ObjekteServiceModule
  ],
  declarations: [ObjekteListComponent],
  exports: [ObjekteListComponent],

})
export class ObjekteListComponentModule { }
